import React from 'react';
import { useLanguage } from 'src/hooks';
import { Language } from 'src/interface';
import { Select, SelectProps } from 'src/components/general';

export const LangSelect: React.FC<{
  className: string;
  design?: SelectProps['design'];
}> = ({ className, design }) => {
  const { currentLang, langList, setLang } = useLanguage();

  return (
    <Select
      value={currentLang}
      items={langList.map((item) => ({
        value: item,
        label: item.toUpperCase(),
      }))}
      selectItem={(item) => {
        setLang(item as Language);
      }}
      design={design}
      className={className}
    />
  );
};

export default LangSelect;
